//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddOrEdit from "./components/AddOrEdit";
export default {
  name: "MenuManagement",
  $dictKeyList: [
    {
      key: "9",
      name: "菜单管理系统标识",
    },
  ],
  components: {
    AddOrEdit,
  },
  data() {
    return {
      filterForm: {
        systemType: "", // 系统表示
        menuName: "", // 菜单名称
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      menuList: [],
      expandAll: false,
      treeLoad: false,
      showAddOrEdit: false,
      dialogType: "add",
      showDialogDelete: false,
      munuData: {},
    };
  },
  mounted() {
    this.getMenuList();
  },
  filters: {
    systemName(val) {
      let obj = {
        2: "运营管理后台",
        3: "合作社",
        4: "村集体",
        6: "县系统",
        7: "乡系统",
        8: "金融机构",
      };
      return obj[val];
    },
  },
  methods: {
    close(type) {
      this[type] = false;
    },
    /**
     * @descripttion: 查询机具
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:07:16
     */
    handleFilterPro() {
      this.pagination.currentPage = 1;
      this.getMenuList((data) => {
        this.menuList = this.rebuildData(
          this.filterForm.menuName.trim(),
          this.filterForm.systemType.trim(),
          data
        );
        this.$nextTick(() => {
          if (this.filterForm.menuName) {
            this.expandAll = true;
            this.toggleRowExpansionAll(this.menuList, this.expandAll);
          }
        });
      });
    },
    /**
     * @description: 展开表格树形结构
     * @Author: yangsibo
     * @Date: 2022-05-27 10:29:59
     * @param {*} data
     * @param {*} expandAll
     * @return {*}
     */
    toggleRowExpansionAll(data, expandAll) {
      try {
        data.forEach((item) => {
          this.$refs.menuTable.toggleRowExpansion(item, expandAll);
          if (item.children !== undefined && item.children !== null) {
            this.toggleRowExpansionAll(item.children, expandAll);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:08:07
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields();
      this.pagination.currentPage = 1;
      this.getMenuList();
    },
    /**
     * @descripttion: 获取菜单列表
     * @Author: juanjuanhui
     * @Date: 2022-02-23 11:41:48
     */
    async getMenuList(callback) {
      this.expandAll = false;
      this.treeLoad = true;
      this.menuList = [];
      try {
        let { data } = await this.$http.menu.selectAllSMenuTree(
          this.filterForm
        );
        this.setDataOrder(data);
        if (callback) {
          callback(data);
        } else {
          this.menuList = data;
        }
        this.treeLoad = false;
      } catch (error) {
        this.treeLoad = false;
      }
    },
    /**
     * @description: 设置序号
     * @Author: yangsibo
     * @Date: 2022-05-26 14:55:39
     * @param {*} data 树形数据
     * @param {*} i 父级序号
     */
    setDataOrder(data, i) {
      data.forEach((item, index) => {
        if (i) {
          item.orderIndex = `${i}.${index + 1}`;
        } else {
          item.orderIndex = index + 1;
        }
        if (item.children) {
          this.setDataOrder(item.children, item.orderIndex);
        }
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getMenuList();
    },
    /**
     * @description: 编辑菜单
     * @Author: yangsibo
     * @Date: 2022-05-26 10:19:05
     * @param {*} data 菜单数据
     */
    handleEditMenu(data) {
      this.dialogType = "edit";
      this.munuData = data;
      this.showAddOrEdit = true;
    },
    /**
     * @description: 删除菜单
     * @Author: yangsibo
     * @Date: 2022-05-26 10:19:05
     * @param {*} data 菜单数据
     */
    handleRemoveMenu(data) {
      this.munuData = data;
      this.showDialogDelete = true;
    },
    /**
     * @description: 删除菜单
     * @Author: yangsibo
     * @Date: 2022-05-30 11:22:26
     * @return {*}
     */
    async handleSaveRemoveAccount() {
      try {
        let { status } = await this.$http.menu.deleteSMenuById({
          id: this.munuData.id,
        });
        if (status == 1) {
          this.$message({
            type: "success",
            message: "删除菜单成功",
            duration: 2000,
          });
          this.showDialogDelete = false;
          this.getMenuList();
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 新增菜单
     * @Author: yangsibo
     * @Date: 2022-05-26 11:22:33
     * @return {*}
     */
    handleAddMenu() {
      this.dialogType = "add";
      this.showAddOrEdit = true;
    },
    // 重点代码 根据name字段模糊匹配树状结构数据，最后将处理好的数据返回出来
    rebuildData(menuName, systemType, arr) {
      if (!arr) {
        return [];
      }
      const newarr = [];

      arr.forEach((item) => {
        // indexOf用来判读当前节点name字段是否包含所搜索的字符串name
        // 返回值：包含则返回索引值，反之返回-1
        if (
          item.menuName.indexOf(menuName) > -1 &&
          (systemType ? item.systemType == systemType : true)
        ) {
          const ab = this.rebuildData(menuName, systemType, item.children);
          const obj = {
            ...item,
            children: ab,
          };
          newarr.push(obj);
        } else {
          // 判断当前节点知否有子节点，并且子节点中有数据，有数据继续递归查找
          if (
            item.children &&
            item.children.length > 0 &&
            (systemType ? item.systemType == systemType : true)
          ) {
            const ab = this.rebuildData(menuName, systemType, item.children);
            const obj = {
              ...item,
              children: ab,
            };
            if (ab && ab.length > 0) {
              newarr.push(obj);
            }
          }
        }
      });
      return newarr;
    },
  },
};
